import Properties from '../components/view-properties.vue';
import Actions from '../components/view-actions.vue';
import Relations from '../components/view-relations.vue';
import Triggers from "../components/view-triggers.vue"
import Settings from "../components/view-settings.vue"
import Experimental from "../components/view-experimental.vue"
import Permissions from "../components/view-permissions.vue";
import PermissionsActionsRows from '../components/view-permissions-section-workarea-table-action-rows.vue';
import PermissionsPropertiesRows from '../components/view-permissions-section-workarea-table-properties-rows.vue';
import PermissionsRelationshipRows from '../components/view-permissions-section-workarea-table-relationship-rows.vue';
import {BuilderArea} from "../enums/builder-area";
import FeatureService from '~/services/featureService'

const routes = [
  {
    name: BuilderArea.properties,
    path: '/properties',
    component: Properties
  },
  {
    name: BuilderArea.actions,
    path: '/actions',
    component: Actions
  },
  {
    name: BuilderArea.triggers,
    path: '/triggers',
    component: Triggers
  },
  {
    name: BuilderArea.relationships,
    path: '/relationships',
    component: Relations
  },
  {
    name: BuilderArea.permissions,
    path: '/permissions',
    component: Permissions,
    redirect: {name: BuilderArea.permissionsActions},
    children: [
      {
        name: BuilderArea.permissionsActions,
        path: 'actions',
        component: PermissionsActionsRows,
        meta: {displayName: 'Actions', parent: BuilderArea.permissions},
      },
      {
        name: BuilderArea.permissionsProperties,
        path: 'properties',
        component: PermissionsPropertiesRows,
        meta: {displayName: 'Properties', parent: BuilderArea.permissions},
      },
      {
        name: BuilderArea.permissionsRelationships,
        path: 'relationships',
        component: PermissionsRelationshipRows,
        meta: {displayName: 'Relationships', parent: BuilderArea.permissions},
      },
    ],
  },
  {
    name: BuilderArea.settings,
    path: '/settings',
    component: Settings
  },
  {
    name: BuilderArea.experimental,
    path: '/experimental',
    component: Experimental,
    beforeEnter: (to, from, next) => {
      if (FeatureService.isOn('create_associated_views') || FeatureService.isOn('object_model_diagrams')) {
        next()
      } else {
        next({name: BuilderArea.settings})
      }
    },
  },
  {
    name: 'null',
    path: '/',
    redirect: {name: BuilderArea.properties},
  }
];

export default routes;